import React from 'react';

/**
 * ShipmentsCards - Card view component for Shipments page
 * Displays shipments in a card grid format
 */
const ShipmentsCards = ({
  shipments,
  onViewShipment,
  formatDate
}) => {
  return (
    <div className="shipments-cards-container">
      {shipments.map((shipment) => (
        <div key={shipment.id} className="shipment-card">
          <div className="card-header">
            <span className="card-shipment-number clickable-link" onClick={() => onViewShipment(shipment)}>
              {shipment.shipment_number}
            </span>
            {Number(shipment.pallet_count) > 0 && Number(shipment.verified_count) === Number(shipment.pallet_count) && (
              <span className="verified-check" title="All pallets verified">
                <svg viewBox="0 0 24 24" width="16" height="16"><path fill="#fff" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              </span>
            )}
          </div>
          <div className="card-body">
            <h3 className="card-customer-name">{shipment.customer_name}</h3>
            <div className="card-details">
              {shipment.invoice_number && (
                <div className="card-detail-item">
                  <span className="detail-label">Invoice:</span>
                  <span className="detail-value">{shipment.invoice_number}</span>
                </div>
              )}
              <div className="card-detail-item">
                <span className="detail-label">Pallets:</span>
                <span className="detail-value">{shipment.pallet_count} pallets</span>
              </div>
              <div className="card-detail-item">
                <span className="detail-label">Weight:</span>
                <span className="detail-value">{parseFloat(shipment.total_weight || 0).toFixed(2)} kg</span>
              </div>
              <div className="card-detail-item">
                <span className="detail-label">Status:</span>
                <span className="detail-value">
                  <span className={`status-badge status-${shipment.status || 'pending'}`}>
                    {shipment.status === 'shipped' ? 'Shipped' : 'Pending'}
                  </span>
                  {shipment.status !== 'shipped' && (
                    shipment.bill_path ? (
                      <span className="bill-indicator has-bill" title="Bill attached">📎</span>
                    ) : (
                      <span className="bill-indicator no-bill" title="No bill uploaded yet">No bill</span>
                    )
                  )}
                </span>
              </div>
              <div className="card-detail-item">
                <span className="detail-label">Date:</span>
                <span className="detail-value">{formatDate(shipment.created_at)}</span>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button
              className="card-action-btn view"
              onClick={() => onViewShipment(shipment)}
            >
              View Details
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ShipmentsCards;
